var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('inline-svg',_vm._b({attrs:{"src":require(("@/assets/svg/" + _vm.name + ".svg"))}},'inline-svg',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }